import { State } from 'src/types'
import { hamidashiOfNormal } from '../hamidashi/normal'
import { middleFingerLeft, middleFingerRight } from 'src/features/dxm/drawer/rightThrow/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/dxm/drawer/rightThrow/glove/back/ringFinger'
import {
  dWaveBottomEmbroideryDrawer,
  dWaveTopEmbroideryDrawer,
  thumbEmbroideryDrawer
} from 'src/features/dxm/drawer/common/back/useCanvasEmbroideries'
import { indexFingerLeft, indexFingerRight } from '../indexFinger'
import { littleFingerLeft, littleFingerRight } from '../littleFinger'
import { thumbAndListBelt, thumbOut } from '../thumbAndListBelt'
import { dWaveListBelt, listBelt } from '../listBelt'
import { indexFingerPad } from '../fingerCoverOrPad/indexFingerPad'
import { fingerCrotch } from '../fingerCrotch'
import { catchFace } from '../catchFace'
import { edgeOfBeltBackStyle } from '../edge/edgeOfBeltBackstyle'
import { edgeOfWrist } from '../edge/edgeOfWrist'
import { middleFingerPad } from '../fingerCoverOrPad/middleFIngerPad'

// 通常ベルトモデル
export const beltBackStyleDrawer = (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): void => {
  if (['crownBackStyle', 'firstBackStyle'].includes(state.backStyle?.value)) return
  if (['crownBackStyle', 'firstBackStyle'].includes(state.baseModel?.backStyle)) return
  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)

  thumbAndListBelt(ctx, state.thumbWeb?.color, state.stitch?.color)
  thumbOut(ctx, state.thumbOut?.color) // 親指＿外
  switch (state.backStyle?.value) {
    case 'dWave':
      indexFingerRight(ctx, state, needCatchFaceWrap)
      dWaveListBelt(ctx, state.listBelt?.color, state.hamidashi.color)
      break
    default:
      // 人差し指＿右... UBackここで描いてる
      indexFingerRight(ctx, state, needCatchFaceWrap)
      listBelt(ctx, state.listBelt?.color, state.stitch?.color)
      break
  }

  // 人差し指＿左
  const isHamidashiCutOption = state.hamidashiCut.value === 'hamidashiCut'
  if (state.baseModel.isUBack) {
    indexFingerLeft(ctx, isHamidashiCutOption ? state.thumbWebAndIndexWeb.color : state.indexMiddle?.color)
  } else {
    indexFingerLeft(ctx, isHamidashiCutOption ? state.indexWeb.color : state.indexMiddle?.color)
  }
  // 中指＿右
  middleFingerRight(ctx, state.middleIndex?.color)
  // 中指＿左
  middleFingerLeft(ctx, state.middleRing?.color)

  // 薬指＿右
  ringFingerRight(ctx, state.ringMiddle?.color)
  // 薬指＿左
  ringFingerLeft(ctx, state.ringLittle?.color)

  // 小指＿右
  littleFingerRight(ctx, state.littleRing?.color)
  // 小指＿左
  littleFingerLeft(ctx, state.littleOut?.color)

  // ハミダシ
  if (state.baseModel.isUBack) {
    const color = isHamidashiCutOption ? state.thumbWebAndIndexWeb.color : state.indexWeb.color
    hamidashiOfNormal(ctx, state.hamidashi?.color, state.hamidashiCut, color)
  } else {
    hamidashiOfNormal(ctx, state.hamidashi?.color, state.hamidashiCut, state.indexWeb.color)
  }

  // 捕球面 / ウェブ下折り返し
  catchFace(ctx, state.catchFace?.color, state.stitch?.color, needCatchFaceWrap)

  // ヘリ革
  edgeOfBeltBackStyle(ctx, state.edge?.color, state.stitch?.color)
  edgeOfWrist(ctx, state.edge?.color, state.stitch?.color)

  // 指当て(人指し指)
  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color)
  // 指当て(中指)
  isMiddleFingerPad && middleFingerPad(ctx, state.indexCover.color, state.stitch.color, -165, 90, -15)
  // 指股
  fingerCrotch(ctx, state.catchFace?.color, state.hamidashi?.color, state.baseModel?.isFingerCrotch)

  thumbEmbroideryDrawer(ctx, state.embroideries, state.backStyle)
  dWaveTopEmbroideryDrawer(ctx, state.embroideries, 0, 0, 0)
  dWaveBottomEmbroideryDrawer(ctx, state.embroideries, 65, 55, 0)
  //
}
